<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        Изменение статуса заказа
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>

      <user-info-label :user="item.user"/>
    </div>
    <div class="os-history-item__content">
      <before-after-log-item>
        <template v-slot:before>
          <label-with-icon icon="clipboard-check">
            {{ oldStatusName }}
          </label-with-icon>
        </template>
        <template v-slot:after>
          <label-with-icon icon="hourglass-half">
            {{ statusName }}
          </label-with-icon>
        </template>
      </before-after-log-item>
    </div>
  </div>
</template>

<script>
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'
  import BeforeAfterLogItem
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/BeforeAfterLogItem'
  import LabelWithIcon
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/LabelWithIcon'
  import OrderStatus from '@/models/enums/OrderStatus'

  export default {
    name: 'HistoryItemTypeStatus',
    components: { LabelWithIcon, BeforeAfterLogItem, UserInfoLabel },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      oldStatusName () {
        return OrderStatus.getName(this.item.oldOrderStatus)
      },
      statusName () {
        return OrderStatus.getName(this.item.orderStatus)
      },
    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";
</style>
